import { render, staticRenderFns } from "./RelativesInfoAdd.vue?vue&type=template&id=77403bc5&scoped=true&"
import script from "./RelativesInfoAdd.vue?vue&type=script&lang=js&"
export * from "./RelativesInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./RelativesInfoAdd.vue?vue&type=style&index=0&id=77403bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77403bc5",
  null
  
)

export default component.exports